import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SFButtonGroup from "./index";
import { SFArrowDownWardIcon, SFArrowUpWardIcon } from "../icons";

const SORT_OPTIONS = [
  { value: "asc", icon: <SFArrowDownWardIcon size="small" /> },
  { value: "desc", icon: <SFArrowUpWardIcon size="small" /> },
  { value: "" },
];

const SFSortButtonGroup = ({
  buttons,
  size = "medium",
  onChange,
  defaultSort = {},
}) => {
  const [selected, setSelected] = useState(defaultSort);

  useEffect(() => {
    onChange(selected);
  }, [selected]);

  const clickBtnHandler = (field) => {
    setSelected((curState) => {
      if (curState?.field === field) {
        let prevSortIndex = SORT_OPTIONS.findIndex((x) => x.value === curState.sort);
        let newSortIndex =
          SORT_OPTIONS.length - prevSortIndex === 1 ? 0 : prevSortIndex + 1;
        let newSortValue = SORT_OPTIONS[newSortIndex].value;
        return { ...curState, sort: newSortValue };
      }
      return { field, sort: SORT_OPTIONS[0].value };
    });
  };

  const getIcon = (field) => {
    if (selected?.field === field) {
      return SORT_OPTIONS.find((x) => x.value === selected.sort)?.icon ?? null;
    }
    return null;
  };

  return (
    <SFButtonGroup
      size={size}
      iconSelectedOnly={true}
      buttons={buttons.map((x) => ({
        ...x,
        selected: x.field === selected?.field,
        icon: getIcon(x.field),
        onClick: () => clickBtnHandler(x.field),
      }))}
    />
  );
};

SFSortButtonGroup.propTypes = {
  iconSelectedOnly: SFButtonGroup.propTypes.iconSelectedOnly,
  size: SFButtonGroup.propTypes.size,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }).isRequired
  ),
};

export default SFSortButtonGroup;
